<script setup lang="ts">
/**
 * Form-control label. Built on Reka `Label` so click-on-label correctly
 * focuses the associated input on both desktop and mobile, including for
 * non-`<input>` controls (radio groups, switches).
 */
import { Label as RekaLabel } from 'reka-ui'
import { computed, useAttrs } from 'vue'

import { cn } from '@/shared/lib/cn'

interface Props {
  /** HTML `for` attribute. */
  for?: string
  /** Show a "required" indicator. */
  required?: boolean
}

const props = withDefaults(defineProps<Props>(), { required: false, for: undefined })

const attrs = useAttrs()
const classes = computed(() =>
  cn(
    'text-sm font-medium text-foreground select-none',
    'peer-disabled:opacity-50',
    (attrs.class as string) ?? '',
  ),
)
</script>

<template>
  <RekaLabel :for="props.for" :class="classes">
    <slot />
    <span v-if="required" aria-hidden="true" class="ml-0.5 text-destructive">*</span>
  </RekaLabel>
</template>
